// Bottom navigation bar — links are relative to the current trip.
import { NavLink, useParams } from "react-router-dom";
import { Home, Map as MapIcon, Ticket, Plane, Sparkles } from "lucide-react";

const items = [
  { sub: "", label: "Hoy", icon: Home, testid: "nav-home" },
  { sub: "map", label: "Mapa", icon: MapIcon, testid: "nav-map" },
  { sub: "sabores", label: "Sabores", icon: Sparkles, testid: "nav-flavors" },
  { sub: "tickets", label: "Tickets", icon: Ticket, testid: "nav-tickets" },
  { sub: "logistica", label: "Logística", icon: Plane, testid: "nav-logistics" },
];

export default function BottomNav() {
  const { tripId } = useParams();
  const base = tripId ? `/viaje/${tripId}` : "";
  return (
    <nav className="bottom-nav" data-testid="bottom-nav">
      <ul className="container-app flex items-center justify-between py-2">
        {items.map((it) => {
          const Icon = it.icon;
          const to = it.sub ? `${base}/${it.sub}` : base || "/";
          return (
            <li key={it.sub} className="flex-1">
              <NavLink
                to={to}
                end={!it.sub}
                data-testid={it.testid}
                className={({ isActive }) =>
                  `flex flex-col items-center gap-0.5 py-1.5 rounded-xl transition-all ${
                    isActive ? "text-[hsl(var(--accent))]" : "text-[hsl(var(--muted))]"
                  }`
                }
              >
                <Icon size={20} strokeWidth={2} />
                <span className="text-[10px] font-medium tracking-wider uppercase">{it.label}</span>
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
